import React from 'react';
import Button from '../../../componentes/button';
import { autobind } from 'core-decorators';
import ContentManager from '../../../componentes/content-manager';
import Avatar from '../../../componentes/avatar';
import SelectImage from '../../../componentes/arquivo-upload/select-image';
import { connect } from 'react-redux';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

@autobind
class AvatarUsuario extends React.Component {
  handleChangeImg() {
    ContentManager.addContent(
      <SelectImage
        tipoAnexo={this.props.tiposAnexos.colaborador}
        idReferencia={this.props.usuarioId}
        model={this.props.model}
        afterUpload={this.afterUpload}
        aspectRatio={1}
        maxSize={2 * 1024 * 1024}
      />
    );
  }

  afterUpload(idReferencia) {
    if (idReferencia) {
      http
        .post('Colaborador/SalvarAlteracaoFoto', { idReferencia })
        .catch((error) => {
          errorHandler(error);
        });
    }
  }

  handleDeletePicture() {
    this.props.model.requestChange(null);
  }

  render() {
    let { model, label, disabled } = this.props;

    return (
      <div style={{ width: '100%', textAlign: 'center', display: 'block' }}>
        <div style={{ width: 120, margin: '0 auto' }}>
          <Avatar
            foto={model && model.value}
            size={120}
            labelSize={60}
            label={label.value}
            showLabel={false}
          />
        </div>
        <div className="mt-2">
          <Button
            disabled={disabled}
            onClick={this.handleChangeImg}
            color="secondary"
            toolbar
            icon="camera"
          />
          <Button
            disabled={disabled}
            className="ml-2"
            outline
            onClick={this.handleDeletePicture}
            color="danger"
            toolbar
            icon="delete-outline"
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    tiposAnexos: state.user.tiposAnexos,
  };
}

export default connect(mapStateToProps)(AvatarUsuario);
